export const epgu_1 = {
	epgu_1_1: require('@/assets/images/epgu/1/1.png'),
	epgu_1_2: require('@/assets/images/epgu/1/2.png'),
	epgu_1_3: require('@/assets/images/epgu/1/3.png'),
};

export const epgu_2 = {
	epgu_2_1: require('@/assets/images/epgu/2/1.png'),
	epgu_2_2: require('@/assets/images/epgu/2/2.png'),
	epgu_2_3: require('@/assets/images/epgu/2/3.png'),
};

export const epgu_3 = {
	epgu_3_1: require('@/assets/images/epgu/3/1.png'),
	epgu_3_2: require('@/assets/images/epgu/3/2.png'),
	epgu_3_3: require('@/assets/images/epgu/3/3.png'),
}

export const epgu_4 = {
	epgu_4_1: require('@/assets/images/epgu/4/1.png'),
	epgu_4_2: require('@/assets/images/epgu/4/2.png'),
	epgu_4_3: require('@/assets/images/epgu/4/3.png'),
}